import actions from './actions'
import getters from './getters'
import * as types from './types'

const state = {
  query: '',
  reference: null,
  index: null
}
const initialState = {
  query: '',
  reference: null,
  index: null
}

const mutations = {
  [types.SET_QUERY_FILTERS](state, action) {
    state.query = action.query
  },
  [types.SET_REFERENCE_QUERY_FILTERS](state, action) {
    state.reference = action.reference
  },
  [types.SET_QUERY_INDEX](state, action) {
    if (state.index !== action.index) {
      state.index = action.index
    }
  },
  [types.SET_RESET_STATE](state, action) {
    Object.assign(state, initialState)
  },
}

export const queryFilters = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
